import script from "./ModalMembrosEquipe.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMembrosEquipe.vue?vue&type=script&setup=true&lang=js"

import "./ModalMembrosEquipe.vue?vue&type=style&index=0&id=10186243&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10186243"]])

export default __exports__